module.exports = __webpack_public_path__ + "img/tienda-1.3e112320.png";